(() => {
  'use strict';

  if (window.__productVariantSubmitGuardLoaded) return;
  window.__productVariantSubmitGuardLoaded = true;

  const PRODUCT_INFO_SELECTOR = 'product-info';
  const VARIANT_SELECTS_SELECTOR = 'variant-selects';
  const VARIANTS_JSON_SELECTOR = '[data-product-variants-json]';
  const FORM_WRAPPER_SELECTOR = '[data-form-wrapper]';
  const ADD_TO_CART_SELECTOR = '[data-add-to-cart]';

  const variantsCache = new WeakMap();

  const normalizeOption = (value) => String(value || '').trim();

  const getVariants = (productInfo) => {
    if (variantsCache.has(productInfo)) return variantsCache.get(productInfo);

    const variantsJson = productInfo.querySelector(VARIANTS_JSON_SELECTOR);
    let variants = [];

    try {
      variants = JSON.parse(variantsJson?.textContent || '[]');
    } catch (error) {
      console.warn('Could not parse product variants JSON:', error);
    }

    variantsCache.set(productInfo, variants);
    return variants;
  };

  const getSelectedOptions = (productInfo) => {
    const variantSelects = productInfo.querySelector(VARIANT_SELECTS_SELECTOR);
    if (!variantSelects) return [];

    return Array.from(variantSelects.querySelectorAll('[data-option-position]'))
      .sort((first, second) => Number(first.dataset.optionPosition) - Number(second.dataset.optionPosition))
      .map((wrapper) => {
        const checkedInput = wrapper.querySelector('fieldset input:checked');
        if (checkedInput) return checkedInput.value;

        const select = wrapper.querySelector('select');
        if (select?.selectedOptions?.length) return select.selectedOptions[0].value;

        return wrapper.querySelector('[data-popout-input]')?.value || '';
      })
      .map(normalizeOption);
  };

  const findSelectedVariant = (productInfo) => {
    const variants = getVariants(productInfo);
    const selectedOptions = getSelectedOptions(productInfo);

    if (!selectedOptions.length) {
      const currentVariantId = productInfo.querySelector('form[data-product-form] input[name="id"]')?.value;
      return variants.find((variant) => String(variant.id) === String(currentVariantId)) || variants[0] || null;
    }

    return variants.find((variant) => {
      const variantOptions = (variant.options || []).map(normalizeOption);
      return variantOptions.length === selectedOptions.length && variantOptions.every((option, index) => option === selectedOptions[index]);
    }) || null;
  };

  const isProductSwap = (productInfo, target) => {
    const productUrl = target?.dataset?.productUrl;
    if (!productUrl) return false;

    try {
      return new URL(productUrl, window.location.origin).pathname !== new URL(productInfo.dataset.url, window.location.origin).pathname;
    } catch (error) {
      return productUrl !== productInfo.dataset.url;
    }
  };

  const updateFormState = (productInfo, variant) => {
    const variantId = variant?.id ? String(variant.id) : '';
    const unavailable = !variant;
    const soldOut = Boolean(variant && variant.available === false);
    const disabled = unavailable || soldOut;

    productInfo.querySelectorAll('form[data-product-form] input[name="id"], form[data-product-form-installment] input[name="id"]').forEach((input) => {
      const changed = input.value !== variantId;
      input.value = variantId;
      input.disabled = disabled;

      if (changed) input.dispatchEvent(new Event('change', {bubbles: true}));
    });

    productInfo.querySelectorAll(ADD_TO_CART_SELECTOR).forEach((button) => {
      button.toggleAttribute('disabled', disabled);
    });

    const formWrapper = productInfo.querySelector(FORM_WRAPPER_SELECTOR);
    formWrapper?.classList.toggle('variant--unavailable', unavailable);
    formWrapper?.classList.toggle('variant--soldout', soldOut);

    return variant;
  };

  const syncVariant = (target, variant) => {
    const productInfo = target?.closest?.(PRODUCT_INFO_SELECTOR) || target;
    if (!productInfo?.matches?.(PRODUCT_INFO_SELECTOR)) return null;

    return updateFormState(productInfo, variant || findSelectedVariant(productInfo));
  };

  document.addEventListener('change', (event) => {
    if (!event.target.closest?.(VARIANT_SELECTS_SELECTOR)) return;

    const productInfo = event.target.closest(PRODUCT_INFO_SELECTOR);
    updateFormState(productInfo, isProductSwap(productInfo, event.target) ? null : findSelectedVariant(productInfo));
  }, true);

  document.addEventListener('submit', (event) => {
    if (!event.target.matches?.('form[data-product-form]')) return;
    syncVariant(event.target);
  }, true);

  document.addEventListener('theme:product-info:loaded', (event) => syncVariant(event.target));
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.(PRODUCT_INFO_SELECTOR).forEach((productInfo) => syncVariant(productInfo));
  });

  if (window.subscribe && window.theme?.PUB_SUB_EVENTS?.variantChange) {
    subscribe(theme.PUB_SUB_EVENTS.variantChange, ({data}) => {
      const productInfo = Array.from(document.querySelectorAll(PRODUCT_INFO_SELECTOR)).find((element) => element.dataset.section === data?.sectionId);
      if (productInfo) updateFormState(productInfo, data.variant);
    });
  }
})();
